import * as React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { ToothStateEnum, Fragments } from "requests";
import { useUpdateState } from "./duck";

interface UpdateStateProps {
  state: ToothStateEnum;
  label: React.ReactNode;
  icon: React.ReactElement;
  selection: NonNullable<Fragments.StoredDentalChartings>;
  onSuccess(): void;
}

const UpdateState: React.FC<UpdateStateProps> = ({
  state,
  label,
  icon,
  selection,
  onSuccess
}) => {
  const { loading, onUpdate } = useUpdateState(onSuccess);

  return (
    <MenuItem
      onClick={() => onUpdate(state, selection)}
      icon={loading ? <Spinner width="12px" height="12px" /> : icon}
    >
      {label}
    </MenuItem>
  );
};

export default UpdateState;
